import { isNilOrEmpty } from '../language/module';
import { AppDocItem } from './appDocItem';


/**
 * A predicate returning whether the given user/resort/DTW combination should be allowed to view the given app doc item.
 * Not null-friendly -- make sure you have values where not explicitly nullable.
 */
export const canShowDocItem = (
  isDtwResort: boolean,
  homeResortAbbrev: string,
  userRole: string,
  docItem: AppDocItem,
) => (isNilOrEmpty(docItem.resorts) || docItem.resorts!.includes('ALL') || docItem.resorts!.includes(homeResortAbbrev))
     && (!docItem.roles || docItem.roles!.includes(userRole))
     && (!docItem.forDtw || isDtwResort); // Not specifically for DTW or we're at a DTW resort

